module.exports = __webpack_public_path__ + "static/media/btn_apple_fr.a7a92e0e.png";